<template>
  <p>
    <span class="date">{{ displayDate }}</span>
    <router-link :to="{name: 'User', params: { username: followed.username }}">
      {{ followed.username }}
    </router-link>
     a {{ win }} en
    <router-link :to="{ path: `/matchs/${matchInfos.id}` }">
      match {{ matchInfos.type }}
    </router-link>
    contre
    <router-link :to="{name: 'User', params: { username: opponent.username }}">
      {{ opponent.username }}
    </router-link>
  </p>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      followed: null,
      matchInfos: null,
      opponent: null
    }
  },
  props: {
    match: {
      required: true,
      type: Object
    }
  },
  created () {
    this.followed = {
      id: this.match.User.id,
      username: this.match.User.username,
      winner: this.match.winner
    }
    this.matchInfos = {
      id: this.match.Match.id,
      type: this.match.Match.MatchType.type
    }
    this.opponent = {
      id: this.match.Match.MatchPlayers[0].User.id,
      username: this.match.Match.MatchPlayers[0].User.username
    }
    console.log(this.followed, this.matchInfos, this.opponent)
  },
  computed: {
    win () {
      if (this.followed.winner === 1) {
        return 'gagné'
      } else {
        return 'perdu'
      }
    },
    displayDate () {
      return moment(this.match.createdAt).format('DD-MM-YYYY hh:mm')
    }
  }
}
</script>

<style scoped>
  p {
    margin-bottom: 10px;
  }
  .date {
    background-color: black;
    color: white;
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FeedListItem.vue